/** @format */

import React, { FunctionComponent } from 'react';
import I18n from '../../components/Translate/I18n';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

export type CallFunctionElementType = {
    name: string | number | null;
    value: string | number | null;
};

export const CallFunctionElement: FunctionComponent<CallFunctionElementType> = ({ name, value }) => {
    if (typeof name === 'number') {
        return (
            <TableRow>
                <TableCell padding="none" align="left">
                    {name}
                </TableCell>
                <TableCell padding="none" align="right">
                    <I18n trans={value} />
                </TableCell>
            </TableRow>
        );
    }
    if (typeof name === 'string') {
        return (
            <TableRow>
                <TableCell padding="none" align="left">
                    <I18n trans={name} />
                </TableCell>
                <TableCell padding="none" align="right">
                    <I18n trans={value} />
                </TableCell>
            </TableRow>
        );
    }
    return null;
};
